import { Box, Divider, Paper } from '@mui/material'
import { Stack } from '@mui/system'
import { max } from 'lodash'
import { FC, ReactNode, memo } from 'react'
import { KanbanTitle } from './KanbanTitle'
import { KanbanItem } from './KanbanItem'
import React from 'react'

export type TColumnOfKanban = {
  title: string;
  type_id: number
  items: Record<string, any>[]
  count?: number
}

type KanbanProps = {
  columns: TColumnOfKanban[]
  colors: Record<TColumnOfKanban['type_id'], string>
  cardContentRenderProp: (props: Record<string, any>) => ReactNode
}

const getMaxHeightOfTitleItems = () => {
  const titleItems = document.querySelectorAll('.kanban__title')

  if (!titleItems?.length) return

  const maxHeight = max(
    [...titleItems].map((item) => item.getBoundingClientRect().height)
  )

  return maxHeight
}
export const Kanban = memo<KanbanProps>(({
  columns,
  colors,
  cardContentRenderProp
})=> {
    const [maxHeightOfTitleItems, setMaxHeightOfTitleItems] = React.useState<number>()

    React.useEffect(() => {
      setMaxHeightOfTitleItems(getMaxHeightOfTitleItems)
    }, [])

  return (
    <Paper
      sx={{
        backgroundColor: '#f5f5f5',
        padding: '10px',
        width: '97vw',
        height: '72vh',
        overflow: 'auto'
      }}
    >
      <Stack
        direction="row"
        spacing={2}
        divider={<Divider flexItem orientation="vertical" />}
      >
        {columns.map((currentItem) => {
          return (
            <Box key={currentItem.type_id} sx={{ width: '200px' }}>
              <KanbanTitle
                color={colors[currentItem.type_id]}
                stageName={currentItem.title}
                count={currentItem.count}
                height={maxHeightOfTitleItems}
              />
              <Stack spacing={2}>
                {currentItem.items.map((item) => {
                  return (
                    <KanbanItem
                      color={colors[currentItem.type_id]}
                      key={item.id}
                      item={item}
                      cardContentRenderProp={cardContentRenderProp}
                    />
                  )
                })}
              </Stack>
            </Box>
          )
        })}
      </Stack>
    </Paper>
  )
}
)
